function ColorIcon({ c, s = 3, p = 2 }: { c: string, s?: number, p?: number }) {
  return (
    <div className={`p-${p} bg-background mr-1 rounded-full`}>
      <div className={`bg-${c} w-${s} h-${s} rounded-full`} />
    </div>
  );
}

export default ColorIcon;
